// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__yP_IL","colCheckbox":"styles_colCheckbox__2Trcs"};